import getEwsRequestDateString from 'owa-mail-store/lib/services/utils/getEwsRequestDateString';
import getServiceContextFolderId from 'owa-mail-store/lib/services/utils/getServiceContextFolderId';
import ApplyConversationActionContext from 'owa-mail-store/lib/store/schema/ApplyConversationActionContext';
import ApplyConversationActionRequest from 'owa-service/lib/contract/ApplyConversationActionRequest';
import ApplyConversationActionResponseMessage from 'owa-service/lib/contract/ApplyConversationActionResponseMessage';
import ConversationAction from 'owa-service/lib/contract/ConversationAction';
import applyConversationActionRequest from 'owa-service/lib/factory/applyConversationActionRequest';
import conversationAction from 'owa-service/lib/factory/conversationAction';
import itemId from 'owa-service/lib/factory/itemId';
import applyConversationActionService from 'owa-mail-store/lib/services/applyConversationActionService';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';

/**
 * Create the restore conversation action used in request body
 * @param conversationContext the conversation context to be restored
 * @param folderId the folder id
 * @return the restore conversation action used in request body
 */
function createConversationAction(
    conversationContext: ApplyConversationActionContext,
    folderId: string
): ConversationAction {
    return conversationAction({
        Action: 'Restore',
        ConversationId: itemId({ Id: conversationContext.conversationId }),
        ContextFolderId: getServiceContextFolderId(folderId),
        ConversationLastSyncTime: getEwsRequestDateString(
            conversationContext.conversationLastSyncTimeStamp
        ),
    });
}

/**
 * Configure the request body
 * @param conversationContexts the conversation contexts to be deleted
 * @param folderId the folder id
 * @return the applyConversationActionRequest body
 */
function configureRequestBody(
    conversationContexts: ApplyConversationActionContext[],
    folderId: string
): ApplyConversationActionRequest {
    const conversationActions = conversationContexts.map(conversationContext =>
        createConversationAction(conversationContext, folderId)
    );

    return applyConversationActionRequest({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: false,
    });
}

/**
 * Restore message service
 * @param conversationContexts the conversation contexts to be deleted
 * @param folderId the folder id
 * @return the ApplyConversationActionResponseMessage
 */
export default function restoreConversationService(
    conversationContexts: ApplyConversationActionContext[],
    folderId: string
): Promise<ApplyConversationActionResponseMessage> {
    const requestBody = configureRequestBody(conversationContexts, folderId);

    // Work Item 27629: Remove workaround for timezone issue (sending requests in UTC time zone)
    const jsonRequestHeader = getJsonRequestHeader();
    jsonRequestHeader.TimeZoneContext.TimeZoneDefinition.Id = 'UTC';

    return applyConversationActionService(requestBody, jsonRequestHeader);
}
